@if (chartTitle.length > 0) {
  <h2 class="chart-title">{{ chartTitle }}</h2>
}
<htc-lexical-table
  [editable]="false"
  [fitToParentElement]="fitToParentElement"
  [usesDefaultBG]="usesDefaultBG"></htc-lexical-table>
